module Client.Components.ContactLookup

open Client
open Client.Services
open Shared
open global.Elmish
open Fable.Core.JsInterop
open System
open Thoth.Fetch
open Thoth.Json
open Fetch.Types
open Feliz
open Feliz.MaterialUI
open Fable.MaterialUI.Icons
open Fable.MaterialUI.MaterialDesignIcons
open Feliz.SweetAlert
open Feliz.UseElmish
open Fable.Core.Experimental
open Fable.Core.JS
open CustomerDexImaging.Models

let strOption (s : string) = if String.IsNullOrWhiteSpace s then None else Some s

type LookupRequestState =
  { Email : string option }

type LookupResultState =
  | Searching
  | NewEntry
  | Initialized


type Model = { LookupRequest : LookupRequestState; Loading : LookupResultState; SuccessCallBack : (ContactSelectionInfo -> unit); Token : string; }

type Msg =
  | UpdateLookupRequest of LookupRequestState
  | LookupRequest of Shared.ContactLookupRequest
  | LookupResult of Result<Contact option,string>
  | AbandonNewEntry
  | NewContactRequest of AddContactRequest

let getEntries (token,(request : Shared.ContactLookupRequest)) : Promise<Contact option> =
  promise {
    let decoder = Services.decoder<Contact option>
    let authHeader = HttpRequestHeaders.Authorization <| sprintf "Bearer %s" token
    return! Fetch.post<_,Contact option>("/api/Contacts/Lookup", request, decoder = decoder,headers = [authHeader] )
  }

let getEntriesCmd token request =
  Cmd.OfPromise.either getEntries (token, request)
    (Ok >> LookupResult)
    (fun x ->
      "Unable to search for contact. Please retry" |> Error |> LookupResult)

let init token successCallBack =
  { LookupRequest = { Email = None; }; Loading = Initialized; SuccessCallBack = successCallBack; Token = token; }, Cmd.none

let update msg model =
  match msg with
  | UpdateLookupRequest r ->
    { model with LookupRequest = r }, Cmd.none
  | AbandonNewEntry ->
    { model with LookupRequest = { Email = None; }; Loading = Initialized; }, Cmd.none
  | LookupRequest r ->
    { model with Loading = Searching; }, getEntriesCmd model.Token r
  | LookupResult r ->
    match r with
    | Ok v ->
      v |> Option.iter (ContactSelectionInfo.Contact >> model.SuccessCallBack)
      { model with Loading = NewEntry }, Cmd.Swal.close()
    | Error msg ->
      let alert =
        Cmd.Swal.fire [
            swal.title "Unable to locate contact. Please try again."
            swal.text msg ]
      { model with Loading = Initialized; }, alert
  | NewContactRequest v ->
    ContactSelectionInfo.NewContact v |> model.SuccessCallBack
    model, Cmd.none

let view = React.functionComponent (fun (inputProps: {| token : string; returnResult: ContactSelectionInfo -> unit; |}) ->
  let model, dispatch = React.useElmish(init inputProps.token inputProps.returnResult, update, [| |])
  let classes = Styles.useStyles()
  let buttonProgressIndicator =
    Mui.circularProgress [
      prop.className classes.buttonProgress
      prop.size 24
    ]
  Html.div [
    match model.Loading with
    | NewEntry ->
      let entryCallBack addContactRequestOption =
        addContactRequestOption
        |> Option.map (NewContactRequest)
        |> Option.defaultValue AbandonNewEntry
        |> dispatch
      Components.ContactEntry.view {| initialEmail = model.LookupRequest.Email; returnResult = entryCallBack |}
    | Initialized
    | Searching ->
      Mui.grid [
        grid.container true
        grid.direction.column
        grid.spacing._2
        grid.children [
          Mui.grid [
            grid.item true
            grid.children [
              Html.text "Please enter email to check for existing contact info."
            ]
          ]
          Mui.grid [
            grid.item true
            grid.children [
              Html.form [
                prop.children [
                  Components.EmailAddress.view {| initialValue = None; allowEntry = true; isRequired = true; returnResult = (fun v -> { model.LookupRequest with Email = v } |> UpdateLookupRequest |> dispatch) |}
                  Html.div [
                    prop.className classes.wrapper
                    prop.children [
                      Mui.button [
                        prop.type'.submit
                        button.fullWidth true
                        button.variant.contained
                        button.color.primary
                        button.children "Search"
                        button.disabled (model.Loading = LookupResultState.Searching || model.LookupRequest.Email.IsNone)
                        prop.onClick (fun e ->
                          e.preventDefault ()
                          match model.LookupRequest.Email with
                          | Some e ->
                            { Shared.ContactLookupRequest.Email = e; } |> LookupRequest |> dispatch
                          | _ -> ()
                        )
                      ]
                      if LookupResultState.Searching = model.Loading then buttonProgressIndicator else Html.none
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
  ]
)